import { Client, Protocol } from '@tencent/mega-ipc-renderer';
import MegaFont from './font/mega-font';
import MegaPlayer from './player/mega-player';
import MegaRuntime from './runtime/mega-runtime';
const MegaLoader = Client.create({
    loader: Protocol(),
}).loader;
class MegaSDK {
}
MegaSDK.Runtime = MegaRuntime;
MegaSDK.Player = MegaPlayer;
MegaSDK.Font = MegaFont;
MegaSDK.Loader = MegaLoader;
export default MegaSDK;
//# sourceMappingURL=mega-sdk.js.map